/*
    accountNumber filter is a standardize filter for representing
    the account number consitently across the site
*/

angular.module('BillPay').filter('accountNumber', function($filter){
    return function(accountNumber){
        return $filter('translate')('labels.accountNumberArg', {number: accountNumber});
    };
});